import { Form, Modal, Button } from 'react-bootstrap';

const Relato = props => {
  return (
    <Form.Group controlId="formRelato" className="mt-4">
      <Form.Label>{props.mensagemRelato}</Form.Label>
      <Form.Control
        maxLength="500"
        className="border border-secondary"
        required={props.isRequired}
        as="textarea"
        rows={5}
        name="formRelato"
        onChange={e => props.handleRelato(e)}
      />
      <span>{props.counter}/500</span>
      
      <Modal show={props.showRelatoModal} onHide={props.handleRelatoModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Erro</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.relatoError}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleRelatoModalClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </Form.Group>
  );
};

export default Relato;
